import { string } from 'prop-types';
import React from 'react';

function Error({ message }) {
  return (
    <div className="Error">
      <span className="Error__message">{message}</span>
    </div>
  );
}

Error.defaultProps = {
  message: 'Something went wrong'
};

Error.propTypes = {
  message: string
};

export default Error;
